<script setup lang="ts">
import { useQuery, useResult } from "@vue/apollo-composable";
import gql from "graphql-tag";
import { ref } from "vue-demi";
import { ClientError, getMessageFromError } from "@/libs/errors";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const authStore = useAuthStore();
const router = useRouter();
const errorMessage = ref("");

// const {loading, error, result, refetch} = useQuery(gql`
//     query Me {
//         me {
//             id
//             name
//         }
//     }
// // `)

// const user = useResult(result, null, data => data.me)

const firstAccess = async () => {
  router.push("/");
};
</script>

<template>
  <div class="login">
    <div class="container">
      <div class="content-center">
        <div class="row">
          <div class="col col-12 d-block">
            <h2 class="mb-4">
              <a href="https://www.quantofaz.com.br">
                <img src="@/assets/images/logo.svg" alt="logo" width="300" />
              </a>
            </h2>
          </div>
          <div class="col col-12">
            <div class="card-plain">
              <header>
                <div class="progress mb-4">
                  <div
                    class="progress-bar bg-pattern"
                    role="progressbar"
                    style="width: 100%"
                    aria-valuenow="25"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <h1>Parabéns</h1>
              </header>
              <form @submit.prevent="firstAccess">
                <div class="buttons d-grid gap-2">
                  <h1>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="64"
                      height="64"
                      fill="currentColor"
                      class="bi bi-person-check"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M15.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L12.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0z"
                      />
                    </svg>
                  </h1>
                  <p>
                    {{ authStore.name }}, você completou seu cadastro com
                    sucesso.
                  </p>
                  <p>
                    Clique abaixo para acessar a sua mais nova plataforma de
                    ofertas abaixo da FIPE!
                  </p>
                  <button type="submit" class="btn btn-primary btn-block">
                    ACESSAR
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.login {
  height: 100vh;
  max-height: 1050px;
  padding: 0;
  position: relative;
  background-color: var(--black-eigengrau);
  /* background-color: #61d; */
}

.login:before {
  /* background-color: #a5c70f; */
  content: "";
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 184px;
  left: 0;
}

.content-center {
  position: relative;
  margin: 0 auto;
  z-index: 99;
  padding: 56px 0 0;
}

h2 {
  font-size: 1.5625rem;
  margin: 0;
  padding: 1.5625rem 0 0.55rem;
  text-align: center;
}

h2 a {
  color: #030303;
  text-decoration: none;
}

.card-plain {
  margin: 0 auto 50px;
  border-radius: 0.5rem;
  max-width: 330px;
  padding: 20px;
  /* background: #daddca; */
  /* -webkit-box-shadow: 0 1px 2px 0 rgb(0 0 0 / 10%); */
  /* box-shadow: 0 1px 2px 0 rgb(0 0 0 / 10%); */
  color: var(--white-ice);
}

.card-plain h1 {
  font-size: 1.5rem;
  line-height: 1.4em;
  margin-bottom: 20px;
  text-align: center;
  color: var(--primary-color);
}

.card-plain .form-control {
  background: var(--black-eigengrau);
  border-color: var(--primary-color);
  color: var(--white-ice);
}

.card-plain .form-control:focus {
  box-shadow: rgba(82, 95, 26, 0.2) 0px 0px 0px 0.25rem;
  color: var(--primary-color);
  font-weight: 500;
}

.btn-check:focus + .btn,
.btn:focus {
  box-shadow: rgba(82, 95, 26, 0.2) 0px 0px 0px 0.25rem;
}

.input-group-text {
  background: #d3d2d3;
  border-color: #030303;
}

.card-plain .buttons {
  margin-top: 2rem;
}

.btn-primary {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: var(--black-eigengrau);
}

.btn-primary:hover {
  box-shadow: rgba(82, 95, 26, 0.2) 0px 0px 0px 0.25rem;
}

.btn-primary:focus {
  box-shadow: rgba(82, 95, 26, 0.2) 0px 0px 0px 0.25rem;
}

.bi.bi-person-check-fill {
  color: var(--primary-color);
}
</style>
